module.exports = "https://cdn.hellotech.com/client-assets/chat-off-hours-desktop_6d2875eaba1e3f5e2d2de84ee49aa93f.png";